import * as MENU_ACTION from 'constant/action/menu'
import * as NUMBER from 'constant/number'
import { createAction } from 'redux-actions'

export const openMenu = createAction(MENU_ACTION.OPEN)
export const closeMenu = createAction(MENU_ACTION.CLOSE)

export const updateMobileView = createAction(MENU_ACTION.MOBILE)

export const setMobileView = () => (dispatch, getState, { menu }) => {
  const mobileView = window.innerWidth < NUMBER.MOBILE
  dispatch(updateMobileView(mobileView))
}
